import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Drawer from '~/Common-Objects/UI/Drawer/Drawer.jsx'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import TemplateCard from '~/Common-Objects/UI/Cards/TemplateCard'
import i18n from '~/i18n'
import { connect } from 'react-redux'

import ImportFile from '~/pages/cp/templates/add/advanced/importFile'
import ImportFromWeb from '~/pages/cp/templates/add/advanced/importWeb'
import ImportFromTemplate from '~/pages/cp/templates/add/advanced/importSite'
import helpers from '~/Classes/helpers'

@connect((store) => {
    return { permissionStore: store.permission, user: store.user, accountMaster: store.accountMaster }
})
class AdvancedTemplates extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploadHtml: false,
            importTemplate: false,
            downloadFromWeb: false
        }

        this.stopAll = this.stopAll.bind(this)
        this.startUploadHtml = this.startUploadHtml.bind(this)
        this.startImportTemplate = this.startImportTemplate.bind(this)
        this.startImportFromWeb = this.startImportFromWeb.bind(this)
        this.finish = this.finish.bind(this)
        this.finishImportFromWeb = this.finishImportFromWeb.bind(this)
    }

    startUploadHtml() {
        this.setState({
            uploadHtml: true,
            importTemplate: false,
            downloadFromWeb: false
        })
    }
    startImportTemplate() {
        this.setState({
            uploadHtml: false,
            importTemplate: true,
            downloadFromWeb: false
        })
    }
    startImportFromWeb() {
        this.setState({
            uploadHtml: false,
            importTemplate: false,
            downloadFromWeb: true
        })
    }
    stopAll() {
        this.setState({
            uploadHtml: false,
            importTemplate: false,
            downloadFromWeb: false
        })
    }

    async finish(template) {
        this.stopAll()
        this.props.campaign.TemplateId = template.id
        this.props.campaign.Template = template
        let useEditorV2 = await helpers.getTemplateEditorVersion(this.props.accountMaster, false)
        this.props.saveCampaign(this.props.campaign).then(() => {
            switch (template.templateType) {
                case 0:
                    if (useEditorV2.canUseV2) {
                        return this.props.history.push('/cp/templates/add/dragDropv2/' + template.id)
                    } else {
                        return this.props.history.push('/cp/templates/add/dragDrop/' + template.id)
                    }
                case 1:
                    return this.props.history.push('/cp/templates/add/fromCode/' + template.id)
                case 2:
                    return this.props.history.push('/cp/templates/add/wysiwyg/' + template.id)
                case 4:
                    return this.props.history.push('/cp/templates/add/fromCode/' + template.id)
            }

            this.props.changeStep(3)
        })
    }

    async finishImportFromWeb(template, importFromWebUrl) {
        this.stopAll()
        this.props.campaign.options.importFromWebUrl = importFromWebUrl
        this.props.campaign.TemplateId = template.id
        this.props.campaign.Template = template
        await this.props.saveCampaign(this.props.campaign)
        return this.props.history.push('/cp/templates/add/fromCode/' + template.id)
    }

    render() {
        return (
            <Paper>
                <Row>
                    <Column md={6} xs={12}>
                        <TemplateCard
                            icon={<Icons icon='list' circle={true} style={{ width: 30, height: 30 }} />}
                            title={i18n.t('templates:add.wysiTitle')}
                            content={i18n.t('templates:add.wysiSubTitle')}
                            button={
                                <Button
                                    text={i18n.t('templates:add.wysiButton')}
                                    className=''
                                    onClick={this.props.createFromWysi}
                                />
                            }
                            style={{ height: '200px' }}
                        />
                    </Column>
                    <Column md={6} xs={12}>
                        <TemplateCard
                            icon={<Icons icon='code' circle={true} style={{ width: 30, height: 30 }} />}
                            title={i18n.t('templates:add.codeTitle')}
                            content={i18n.t('templates:add.codeSubTitle')}
                            button={
                                <Button
                                    text={i18n.t('templates:add.codeButton')}
                                    className=''
                                    onClick={this.props.createFromCode}
                                />
                            }
                            style={{ height: '200px' }}
                        />
                    </Column>
                    <Column md={4} xs={12}>
                        <TemplateCard
                            icon={<Icons icon='upload' circle={true} style={{ width: 30, height: 30 }} />}
                            title={i18n.t('templates:add.advanced.uploadTitle')}
                            content={i18n.t('templates:add.advanced.uploadSubTitle')}
                            button={
                                <Button
                                    text={i18n.t('templates:add.advanced.uploadButton')}
                                    className=''
                                    onClick={this.startUploadHtml}
                                />
                            }
                            style={{ height: '200px' }}
                        />
                    </Column>
                    <Column md={4} xs={12}>
                        <TemplateCard
                            icon={<Icons icon='download' circle={true} style={{ width: 30, height: 30 }} />}
                            title={i18n.t('templates:add.advanced.importTitle')}
                            content={i18n.t('templates:add.advanced.importSubTitle')}
                            button={
                                <Button
                                    text={i18n.t('templates:add.advanced.importButton')}
                                    className=''
                                    onClick={this.startImportTemplate}
                                />
                            }
                            style={{ height: '200px' }}
                        />
                    </Column>
                    <Column md={4} xs={12}>
                        <TemplateCard
                            icon={<Icons icon='world' circle={true} style={{ width: 30, height: 30 }} />}
                            title={i18n.t('templates:add.advanced.webTitle')}
                            content={i18n.t('templates:add.advanced.webSubTitle')}
                            button={
                                <Button
                                    text={i18n.t('templates:add.advanced.webButton')}
                                    className=''
                                    onClick={this.startImportFromWeb}
                                />
                            }
                            style={{ height: '200px' }}
                        />
                    </Column>
                </Row>
                <Drawer
                    isOpen={this.state.uploadHtml}
                    startClose={this.stopAll}
                    standalone={true}
                    showClose={true}
                >
                    <ImportFile finish={this.finish} campaignId={this.props.campaign.id} />
                </Drawer>
                <Drawer
                    isOpen={this.state.importTemplate}
                    startClose={this.stopAll}
                    standalone={true}
                    showClose={true}
                >
                    <ImportFromTemplate finish={this.finish} campaignId={this.props.campaign.id} />
                </Drawer>

                <Drawer
                    isOpen={this.state.downloadFromWeb}
                    startClose={this.stopAll}
                    standalone={true}
                    showClose={true}
                >
                    <ImportFromWeb finish={this.finishImportFromWeb} campaignId={this.props.campaign.id} />
                </Drawer>
            </Paper>
        )
    }
}

export default AdvancedTemplates
